/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestGoldfinchConfig extends Contract<ITestGoldfinchConfig> {
  getNumber: Call<(_index: BigNumberish) => BigNumber, ITestGoldfinchConfig>
  'getNumber(uint256)': Call<(_index: BigNumberish) => BigNumber, ITestGoldfinchConfig>
}

let ITestGoldfinchConfigBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestGoldfinchConfigBytecode = '0x';
}

// prettier-ignore
export const ITestGoldfinchConfig = contract<ITestGoldfinchConfig>(ITestGoldfinchConfigBytecode)`
  function getNumber(uint256 _index) view returns (uint256 number_)
`;